import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d9824d5a&scoped=true&lang=pug&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=d9824d5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9824d5a",
  null
  
)

export default component.exports